import { Link } from 'react-router-dom';
import categories from '@/mocks/categories';

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-secondary-950 text-secondary-100">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-label text-xl text-secondary-50">糖心吃瓜</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">
              只磕甜向小瓜，把恋爱小料、心动瞬间、官宣现场与情侣小事整理成一片清爽的甜瓜田。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="mailto:hello@tangxinchigua.com"
                aria-label="邮件联系"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-900 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line" aria-hidden="true"></i>
              </a>
              <a
                href="mailto:hello@tangxinchigua.com"
                aria-label="投稿甜瓜"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-900 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-quill-pen-line" aria-hidden="true"></i>
              </a>
              <a
                href="mailto:hello@tangxinchigua.com"
                aria-label="订阅咨询"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-900 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-notification-3-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <nav aria-label="站点导航">
            <h4 className="text-sm font-medium text-secondary-50">浏览甜瓜</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/" className="hover:text-primary-300 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/fresh" className="hover:text-primary-300 transition-colors cursor-pointer">瓜田速递</Link></li>
              <li><Link to="/about" className="hover:text-primary-300 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </nav>

          <nav aria-label="甜瓜分类">
            <h4 className="text-sm font-medium text-secondary-50">甜瓜分类</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/fresh?category=${cat.slug}`}
                    className="hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-medium text-secondary-50">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-secondary-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-300" aria-hidden="true"></i>
                <a href="mailto:hello@tangxinchigua.com" className="hover:text-primary-300 transition-colors cursor-pointer">
                  hello@tangxinchigua.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-primary-300" aria-hidden="true"></i>
                <span>工作日 10:00 - 19:00 上新甜瓜</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-300" aria-hidden="true"></i>
                <span>线上编辑部 · 欢迎来信投稿</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-secondary-800 pt-6 text-xs text-secondary-400">
          <p>© 2026 糖心吃瓜 · 只记录让人嘴角上扬的甜味瓜</p>
          <p>本站内容来自公开渠道整理，如涉侵权请来信告知，我们将及时处理。</p>
        </div>
      </div>
    </footer>
  );
}